import { render, staticRenderFns } from "./ListOfPartner.vue?vue&type=template&id=2af75c6a&scoped=true"
import script from "./ListOfPartner.vue?vue&type=script&lang=js"
export * from "./ListOfPartner.vue?vue&type=script&lang=js"
import style0 from "./ListOfPartner.vue?vue&type=style&index=0&id=2af75c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af75c6a",
  null
  
)

export default component.exports